import { useCallback, useMemo } from 'react'

import { xor } from 'lodash'

import { moveOnPinToggle, resolveColumnOrder } from '@Components/ColumnsConfig/utils'
import { columnKey, isColumnConfigurable, useGrid } from '@Components/Grid/context'

export default function useGridColumnActions() {
  const { columns, columnOrder, setColumnOrder, pinnedColumns, setPinnedColumns, hiddenColumns, setHiddenColumns } = useGrid()

  const togglePin = useCallback(key => {
    const nextPinned = xor(pinnedColumns, [key])
    const keys = (columns || []).filter(isColumnConfigurable).map(columnKey)
    setPinnedColumns(nextPinned)
    setColumnOrder(moveOnPinToggle(resolveColumnOrder(columnOrder, keys), key, nextPinned))
  }, [columns, columnOrder, pinnedColumns, setColumnOrder, setPinnedColumns])

  const hide = useCallback(key => {
    if (!hiddenColumns.includes(key)) {
      setHiddenColumns([...hiddenColumns, key])
    }
  }, [hiddenColumns, setHiddenColumns])

  return useMemo(() => ({ togglePin, hide }), [togglePin, hide])
}
